"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
var _dataAdmin = require("@/api/dataAdmin");
var _download = require("@/utils/download");
var _AcquisitionTime = require("@/utils/AcquisitionTime");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CoreDataStatistics',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      dateRange: [],
      queryParams: {
        page: 1,
        size: 20,
        timeRange: 1,
        startDate: '',
        endDate: ''
      },
      timeRangeOptions: [{
        label: '全部',
        value: 1
      }, {
        label: '最近7天',
        value: 2
      }, {
        label: '最近30天',
        value: 3
      }, {
        label: '本月',
        value: 4
      }, {
        label: '上月',
        value: 5
      }, {
        label: '自定义时间范围',
        value: 6
      }],
      exportDialogVisible: false,
      activeExportTab: 'export',
      exportForm: {
        fileName: '',
        fileType: 0
      },
      exportRules: {
        fileName: [{
          required: true,
          message: '请输入文件名',
          trigger: 'blur'
        }],
        fileType: [{
          required: true,
          message: '请选择导出格式',
          trigger: 'change'
        }]
      },
      recordQueryParams: {
        page: 1,
        size: 10,
        recordType: 0,
        moduleId: 1,
        fileName: '',
        status: undefined
      },
      recordTotal: 0,
      recordTableData: [],
      recordLoading: false
    };
  },
  mounted: function mounted() {
    this.initQueryParams();
    this.fetchData();
  },
  methods: {
    initQueryParams: function initQueryParams() {
      // 默认全部，不传日期
      this.queryParams.timeRange = 1;
      this.queryParams.startDate = '';
      this.queryParams.endDate = '';
      this.dateRange = [];
    },
    fetchData: function fetchData() {
      var _this = this;
      this.loading = true;
      var params = {
        page: this.queryParams.page,
        size: this.queryParams.size,
        timeRange: this.queryParams.timeRange,
        startDate: this.queryParams.startDate,
        endDate: this.queryParams.endDate
      };
      (0, _dataAdmin.queryCoreDataHistory)(params).then(function (res) {
        if (res.data) {
          _this.tableData = res.data.data || [];
          _this.total = res.data.total || 0;
        }
      }).catch(function () {}).finally(function () {
        _this.loading = false;
      });
    },
    onTimeRangeChange: function onTimeRangeChange(val) {
      this.queryParams.timeRange = val;
      if (val === 6) {
        this.dateRange = [];
        this.queryParams.startDate = '';
        this.queryParams.endDate = '';
        return;
      }
      // 根据选项自动设置日期
      var range = [];
      switch (val) {
        case 1:
          // 全部：不传日期
          range = [];
          break;
        case 2:
          range = (0, _AcquisitionTime.getLast7Days)();
          break;
        case 3:
          range = (0, _AcquisitionTime.getLast30Days)();
          break;
        case 4:
          range = (0, _AcquisitionTime.getLastCurrentMonth)();
          break;
        case 5:
          range = (0, _AcquisitionTime.getLastMonthDates)();
          break;
      }
      if (range.length === 2) {
        this.dateRange = range;
        this.queryParams.startDate = range[0];
        this.queryParams.endDate = range[1];
      } else {
        this.dateRange = [];
        this.queryParams.startDate = '';
        this.queryParams.endDate = '';
      }
      this.queryParams.page = 1;
      this.fetchData();
    },
    onDateRangeChange: function onDateRangeChange(val) {
      if (val && val.length === 2) {
        this.queryParams.startDate = val[0];
        this.queryParams.endDate = val[1];
      } else {
        this.queryParams.startDate = '';
        this.queryParams.endDate = '';
      }
    },
    onQuery: function onQuery() {
      if (this.queryParams.timeRange === 6) {
        if (!this.dateRange || this.dateRange.length !== 2) {
          this.$message.warning('请选择自定义时间范围');
          return;
        }
      }
      this.queryParams.page = 1;
      this.fetchData();
    },
    onReset: function onReset() {
      this.initQueryParams();
      this.queryParams.page = 1;
      this.queryParams.size = 20;
      this.fetchData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryParams.size = val;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchData();
    },
    openExportDialog: function openExportDialog() {
      this.exportDialogVisible = true;
      this.activeExportTab = 'export';
      this.exportForm.fileName = '';
      this.exportForm.fileType = 0;
      this.fetchExportRecord();
    },
    onExportDialogClose: function onExportDialogClose() {
      this.$refs.exportForm && this.$refs.exportForm.resetFields();
    },
    onConfirmExport: function onConfirmExport() {
      var _this2 = this;
      this.$refs.exportForm.validate(function (valid) {
        if (!valid) return;
        _this2.$confirm('确认导出该数据？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          var params = {
            fileName: _this2.exportForm.fileName,
            fileType: _this2.exportForm.fileType,
            timeRange: _this2.queryParams.timeRange,
            startDate: _this2.queryParams.startDate,
            endDate: _this2.queryParams.endDate
          };
          (0, _dataAdmin.exportCoreData)(params).then(function (res) {
            _this2.$message.success('导出任务已创建');
            _this2.exportDialogVisible = false;
          }).catch(function () {
            _this2.$message.error('导出失败');
          });
        }).catch(function () {});
      });
    },
    onResetExport: function onResetExport() {
      this.$refs.exportForm.resetFields();
    },
    onExportTabClick: function onExportTabClick(tab) {
      if (tab.name === 'record' && this.recordTableData.length === 0) {
        this.fetchExportRecord();
      }
    },
    fetchExportRecord: function fetchExportRecord() {
      var _this3 = this;
      this.recordLoading = true;
      var params = (0, _objectSpread2.default)({}, this.recordQueryParams);
      if (params.status === undefined || params.status === null || params.status === '') {
        delete params.status;
      }
      if (!params.fileName) {
        delete params.fileName;
      }
      (0, _dataAdmin.queryExportRecord)(params).then(function (res) {
        if (res.data) {
          _this3.recordTableData = res.data.data || [];
          _this3.recordTotal = res.data.total || 0;
        }
      }).catch(function () {}).finally(function () {
        _this3.recordLoading = false;
      });
    },
    onQueryRecord: function onQueryRecord() {
      this.recordQueryParams.page = 1;
      this.fetchExportRecord();
    },
    onResetRecord: function onResetRecord() {
      this.recordQueryParams = {
        page: 1,
        size: 10,
        recordType: 0,
        moduleId: 1,
        fileName: '',
        status: undefined
      };
      this.fetchExportRecord();
    },
    handleRecordSizeChange: function handleRecordSizeChange(val) {
      this.recordQueryParams.size = val;
      this.fetchExportRecord();
    },
    handleRecordCurrentChange: function handleRecordCurrentChange(val) {
      this.recordQueryParams.page = val;
      this.fetchExportRecord();
    },
    onDownloadRecord: function onDownloadRecord(row) {
      var _this4 = this;
      this.$confirm('确认下载该文件？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var params = {
          recordType: 0,
          taskId: row.taskId
        };
        (0, _dataAdmin.downloadExportFile)(params).then(function (res) {
          if (res.data) {
            var url = res.data;
            if (url.startsWith('http')) {
              var link = document.createElement('a');
              link.href = url;
              link.download = row.fileName || '';
              link.style.display = 'none';
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } else {
              (0, _download.selfDownload)(url);
            }
          } else {
            _this4.$message.warning('下载链接为空');
          }
        }).catch(function () {
          _this4.$message.error('下载失败');
        });
      }).catch(function () {});
    }
  }
};